import { shallowReactive, computed, ComputedRef } from 'vue';
import {ICustomFilter} from "./LocationFinderTypes"

export class CustomFilterManager {
    public Filters: ICustomFilter[]

    constructor(customFilters: ICustomFilter[]){
        this.Filters = customFilters.map((filter) => ({ ...filter, Selected: false }) )
    }

    public SelectedFiltersId() {
        return this.Filters.filter(elm => elm.Selected).map(item => item.Id)
    }

    public IsAnyFilterSelected() {
        return (this.Filters.filter(elm => elm.Selected).length > 0);
    }

    public ToggleFilter(id: string) {
        this.Filters = this.Filters.map(elm => elm.Id == id ? { ...elm, Selected: !elm.Selected } : elm)
    }

    public SetAllFiltersSelectionTo(option: boolean) {
        this.Filters = this.Filters.map(elm => ({ ...elm, Selected: option}))
    }
}

export default function GetCustomFilterManager(customFilters: ICustomFilter[]) {
    return shallowReactive(new CustomFilterManager(customFilters))
}
